<template>
  <mdb-container>
    <Errors v-if="error" :error="error" />
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>

    <mdb-alert
      color="dark"
      v-if="message"
      @closeAlert="message = false"
      dismiss
    >
      {{ message }}
    </mdb-alert>

    <form @submit.prevent="createOrUpdateStation">
      <mdb-col col="12" class="pb-2 justify-content-md-center">
        <mdb-row>
          <mdb-col col="4">
            <mdb-select
              required
              search
              v-model="scanLocations"
              placeholder="Select"
              label="Where is this station? e.g Warehouse"
              @getValue="setStationLocation"
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-select
              required
              search
              v-model="scanStates"
              placeholder="Select"
              label="Station state"
              @getValue="setStationState"
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              :disabled="!isDisabled"
              outline="primary"
              type="submit"
              :icon="btnInfo.btnIcon"
              >{{ btnInfo.btnName }}</mdb-btn
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </form>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";
import { uuid } from "vue-uuid";

import {
  mdbRow,
  mdbCol,
  mdbContainer,
  mdbBtn,
  mdbAlert,
  mdbSelect,
} from "mdbvue";

export default {
  components: {
    Errors,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbBtn,
    mdbAlert,
    Spinner,
    mdbSelect,
  },

  props: {
    station: {
      type: Object,
    },
  },
  data() {
    return {
      stationInfo: {},
      error: "",
      scanStates: [],
      scanLocations: [],
      btnInfo: {},
      isLoading: true,
      message: "",
    };
  },
  methods: {
    newStation() {
      return {
        code: "",
        location: "",
        scan_state: "",
      };
    },

    setStationLocation(val) {
      this.stationInfo.location = val;
    },

    setStationState(val) {
      this.stationInfo.scan_state = val;
    },

    setStationInfo() {
      return {
        code: this.station.code,
        location: this.station.location,
        scan_state: this.station.scan_state,
      };
    },

    setUpdate() {
      if (this.station || this.station === null) {
        return true;
      } else {
        return false;
      }
    },

    createOrUpdateStation() {
      this.setUpdate() ? this.updateStation() : this.createStation();
    },

     getLocationList() {
      api
        .getAllLocations()
        .then((response) => {
          this.scanLocations = [...response.data];
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    updateStation() {
      this.isLoading = true;
      api
        .updateStation(this.station.id, this.stationInfo)
        .then((response) => {
          this.$emit("station-updated", response.data);
          this.isLoading = false;
          this.message = "Update Successful";
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },

    createStation() {
      this.stationInfo.code = uuid.v4();
      api
        .createStation(this.stationInfo)
        .then((response) => {
          this.$emit("station-created", response.data);
          this.reset();
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
    reset() {
      this.stationInfo = this.newStation();
      this.error = "";
    },

    setBtnInfo() {
      return this.setUpdate()
        ? { btnName: "Update", btnIcon: "sync" }
        : { btnName: "Create Station", btnIcon: "plus" };
    },
    validInput() {
      return (
        this.scanStates.includes(this.stationInfo.scan_state) &&
        this.scanLocations.includes(this.stationInfo.location)
      );
    },
  },

  created() {
    // Fetch scan states
    api.getScanStates().then((response) => {
      response.data.forEach((s) => {
        let selected =
          this.station && this.station.scan_state == s ? true : false;
        this.scanStates.push({
          text: s,
          value: s,
          selected: selected,
        });
      });

      // //set scan locations
      // this.scanLocations = [
      //   { text: "Warehouse", value: "warehouse", selected: true },
      // ];
    });

    this.getLocationList();

    this.stationInfo = this.station ? this.setStationInfo() : this.newStation();
    this.btnInfo = this.setBtnInfo();
    this.isLoading = false;
  },
  mounted() {},
  computed: {
    showSpinner() {
      return this.isLoading;
    },

    isDisabled() {
      return !!this.stationInfo.location && !!this.stationInfo.scan_state;
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  color: $black-accent-color;
  border-color: $black-accent-color;
  text-transform: uppercase;

  &:hover {
    background-color: $green-accent-color;
    color: white;
  }
}
</style>
